export default __webpack_public_path__ + "static/media/sounds/clpl_practice_intro.mp3";